module.exports = __webpack_public_path__ + "img/0S6A9851.60231f95.jpg";